export enum BillChargeType {
    NEW_CASE = 1,
    FOLLOWUP = 2,
    DRESSING = 3
}
export const BillChargeTypeLabels: Record<BillChargeType, string> = {
    [BillChargeType.NEW_CASE]: "New Case",
    [BillChargeType.FOLLOWUP]: "Followup",
    [BillChargeType.DRESSING]: "Dressing",
};
